export default {
  backBtn: ({ commit }, choice) => {
    commit("showBackBtn", choice);
  },
  loading: ({ commit }, val) => {
    commit("loading", val);
  },  
};
